export class RegionUsageReport {
    region?: string;
    activeAccounts?: number;
    inactiveAccounts?: number;
    activeEnvironments?: number;
    inactiveEnvironments?: number;
}
